import { EditionsService } from './../../services/editions.service';
import { Edition } from './../../models/edition.model';
import { PublishStatusApiResponse } from './../../models/publish-status-api-response.model';
import { PublishService } from './../../services/publish.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SelectionModel } from '@angular/cdk/collections';
import { ProductStatistics } from '../../models/product-statistics.model';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-publish-edition',
  templateUrl: './publish-edition.component.html',
  styleUrls: ['./publish-edition.component.scss']
})
export class PublishEditionComponent implements OnInit {
  id: string;
  data: PublishStatusApiResponse;
  edition: Edition;
  totalDocuments: number;
  selection = new SelectionModel<ProductStatistics>(true, []);
  omitInProgressDocuments = false;
  draftHref: string;
  definitiveHref: string;
  hasProducts: boolean;
  constructor(
    private activatedRoute: ActivatedRoute,
    private publishService: PublishService,
    private editionService: EditionsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.refresh();
  }

  refresh() {
    this.getEdition();
    this.getPublish();
  }

  getPublish() {
    this.publishService.getPublishStatus(this.id).subscribe(v => {
      this.data = v;
      this.hasProducts = v.products && v.products.length > 0;
      if (this.hasProducts) {
        this.totalDocuments = v.products
          .map(r => r.quantity)
          .reduce((a, b) => a + b);
      }
    });
  }

  getEdition() {
    this.editionService.getEdition(this.id).subscribe(v => (this.edition = v));
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.products.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.data.products.forEach(row => this.selection.select(row));
    this.updateHref();
  }

  updateHref() {
    const d: any = {};
    d.editionId = this.edition.id;
    d.selectedProducts = this.selection.selected.map(v => v.productCode);
    const query: HttpParams = new HttpParams({ fromObject: d });
    this.draftHref = `/generar?${query.toString()}`;
    this.definitiveHref = `/generar-definitivo?${query.toString()}`;
  }

  goBack() {
    this.router.navigateByUrl(`/exportar`);
  }
}
